import React from 'react';
import {Container, Typography, Box} from '@mui/material';
import SectionTitle from "./SectionTitle";

function AboutMe() {
    return (
        <Container sx={{ padding: '64px 0', overflow: 'hidden'}}>
            <SectionTitle title={'About Me'} />
            <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', gap: '32px' }}>
                <Typography variant="p" fontSize={'larger'}>
                    Engineering Manager with over a decade of experience in the tech industry, built on a strong foundation as a Full Stack Engineer.
                </Typography>
                <Typography variant="p" fontSize={'larger'}>
                    Skilled in all stages of product development and project management, from ideation to deployment.
                </Typography>
                <Typography variant="p" fontSize={'larger'}>
                    Experienced in leading teams, executing complex projects, and balancing innovation with risk and business impact.
                </Typography>
                <Typography variant="p" fontSize={'larger'}>
                    Industry background includes eCommerce, publishing, consulting, and logistics.
                </Typography>
            </Box>
        </Container>
    );
}

export default AboutMe;